<template>
  <div class="bill-detail">
    <page-title title="抬头信息">
      <div class="info-container">
        <div class="info-item">
          <span class="label">发票类型：</span>
          <span class="content">{{
            formOptions.titleInfo.invoiceType === 1
              ? "增值税普通发票（电子）"
              : "增值税专用发票（电子）"
          }}</span>
        </div>
        <div class="info-item">
          <span class="label">抬头名称：</span>
          <span class="content">{{
            formOptions.titleInfo.titleInfo ||
              formOptions.titleInfo.invoiceTitle
          }}</span>
        </div>
        <div class="info-item">
          <span class="label">税号：</span>
          <span class="content">{{
            formOptions.titleInfo.taxId ||
              formOptions.titleInfo.taxpayerIdentificationNumber
          }}</span>
        </div>
        <div class="info-item">
          <span class="label">开户行账号：</span>
          <span class="content">{{
            formOptions.titleInfo.bankNumber ||
              formOptions.titleInfo.bankAccount
          }}</span>
        </div>
        <div class="info-item">
          <span class="label">公司开户行：</span>
          <span class="content">{{
            formOptions.titleInfo.openBank ||
              formOptions.titleInfo.bankOfDeposit
          }}</span>
        </div>
        <div class="info-item">
          <span class="label">公司地址：</span>
          <span class="content">{{
            formOptions.titleInfo.companyAddress ||
              formOptions.titleInfo.companyRegisteredAddress
          }}</span>
        </div>
        <div class="info-item">
          <span class="label">公司电话：</span>
          <span class="content">{{
            formOptions.titleInfo.companyPhone ||
              formOptions.titleInfo.registrationTelephone
          }}</span>
        </div>
      </div>
    </page-title>
    <page-title title="发票信息">
      <div class="info-container">
        <div class="info-item">
          <span class="label">电子邮箱：</span>
          <span class="content">{{ formOptions.emailAddr }}</span>
        </div>
        <div class="info-item">
          <span class="label">开票金额：</span>
          <span class="content">{{ formOptions.invoiceCount }}</span>
        </div>
        <div class="info-item">
          <span class="label">开票备注：</span>
          <span class="content">{{ formOptions.remark }}</span>
        </div>
      </div>
      <div class="button-container">
        <el-button
          type="primary"
          v-if="!statusList.includes(formOptions.status)"
          @click="updateFun('已处理')"
          >处理</el-button
        >
        <el-button @click="$router.go(-1)">关闭</el-button>
      </div>
    </page-title>
    <page-title title="订单信息">
      <el-table
        v-loading="tableLoading"
        :data="orderList"
        border
        style="width: 100%; margin-top: 20px;"
        :header-cell-style="{ backgroundColor: '#F5F7FA' }"
      >
        <el-table-column prop="code" label="订单号" />
        <el-table-column prop="orderType" label="订单类型">
          <template slot-scope="scope">
            <span v-if="scope.row.orderType === 0">充值</span>
            <span v-else-if="scope.row.orderType === 1">套餐</span>
            <span v-else-if="scope.row.orderType === 2">图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="payPrice" label="实付金额">
          <template slot-scope="scope"> ¥{{ scope.row.payPrice }} </template>
        </el-table-column>
        <el-table-column prop="createTime" label="下单时间" />
        <el-table-column prop="payMode" label="支付方式">
          <template slot-scope="scope">
            <span v-if="scope.row.payMode === 0">支付宝</span>
            <span v-else-if="scope.row.payMode === 1">微信</span>
          </template>
        </el-table-column>
      </el-table>
    </page-title>
  </div>
</template>

<script>
import { billUpdate } from "@/api/req";
import { invoiceRecord } from "@/api/invoice";
import PageTitle from "@/components/pageTitle.vue";
export default {
  mixins: [],
  components: {
    PageTitle,
  },
  props: {},
  watch: {},
  computed: {},
  data() {
    return {
      statusList: ["已处理"],
      formOptions: {},
      orderList: [],
      tableLoading: false,
    };
  },
  created() {
    const detail = sessionStorage.getItem('billDetial')
    console.log("qs", detail);
    try {
      // 先获取并解析整个 detail
      
      this.formOptions = detail
        ? JSON.parse(decodeURIComponent(detail))
        : {};

      // 优先使用 newTitleInfo，如果不存在则使用 titleInfo
      if (this.formOptions.newTitleInfo) {
        this.formOptions.titleInfo =
          typeof this.formOptions.newTitleInfo === "string"
            ? JSON.parse(decodeURIComponent(this.formOptions.newTitleInfo))
            : this.formOptions.newTitleInfo;
      } else if (typeof this.formOptions.titleInfo === "string") {
        this.formOptions.titleInfo = JSON.parse(
          decodeURIComponent(this.formOptions.titleInfo)
        );
      }

      // 处理 feedback
      this.formOptions.feedback =
        this.formOptions.feedback === "undefined"
          ? ""
          : this.formOptions.feedback;

      console.log("this.formOptions", { ...this.formOptions });
      this.getOrderList();
    } catch (error) {
      console.error("数据解析错误:", error);
      this.formOptions = {};
      this.formOptions.titleInfo = {};
    }
  },
  methods: {
    updateFun(status) {
      this.$ajax
        .post(`${billUpdate}?id=${this.formOptions.id}&status=${status}`, {
          status,
          id: this.formOptions.id,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: "更新成功",
            type: "success",
            center: true,
            duration: 3000,
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        });
    },
    getOrderList() {
      if (this.formOptions.orderIds) {
        this.tableLoading = true;
        this.$ajax
          .get(invoiceRecord(this.formOptions.orderIds))
          .then((res) => {
            console.log(res);
            const { data } = res;
            if (data?.code === 200) {
              this.orderList = data?.data || [];
            } else {
              this.$message.error(data?.msg || "获取订单列表失败");
            }
          })
          .catch((error) => {
            console.error("获取订单列表失败:", error);
          })
          .finally(() => {
            this.tableLoading = false;
          });
      }
    },
  },
  mounted() {},
  updated() {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.bill-detail {
  padding: 20px;

  // 修改表格表头样式
  :deep(.el-table) {
    thead {
      tr {
        th {
          background-color: #f5f7fa !important;
        }
      }
    }
    // 确保表头在固定和非固定状态下都有正确的背景色
    .el-table__header th,
    .el-table__fixed-header-wrapper th {
      background-color: #f5f7fa !important;
    }
  }

  .info-container {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .info-item {
      width: calc(50% - 10px);
      display: flex;
      align-items: flex-start;
      min-height: 32px;

      .label {
        flex-shrink: 0;
        width: 100px;
        color: #909399;
        text-align: right;
        padding-right: 12px;
      }

      .content {
        flex: 1;
        color: #303133;
        word-break: break-all;
      }
    }
  }

  .button-container {
    margin-top: 20px;
    padding: 0 20px;
  }
}
</style>
